import Axios from 'axios';

export interface LoginResponse {
    Token: string;
    Email: string;
    Admin: boolean;
}

export class AuthManagerClass {
    public debug: boolean = true;
    public auth: boolean;
    public token: string;
    public admin: boolean;
    public email: string;

    constructor() {
        this.auth = false;
        this.token = '';
        this.admin = false;
        this.email = '';
    }

    public getToken(): string {
        let token = localStorage.getItem('Authentication token');
        if (token === null) {
            token = '';
        }
        return token;
    }

    public setAuth(vue: any, isAuth: boolean, isAdmin: boolean, token: string) {
        if (this.debug) {
            console.log('set Auth to', isAuth);
            // this.$store.state.auth
        }
        this.auth = isAuth;
        this.admin = isAdmin;
        if (isAuth) {
            vue.$store.commit('setAuth');
            this.setAuthHeader(token);
            this.saveToken(token);
            const thisConst = this;

            if (isAdmin) {
                vue.$store.commit('setAdmin');
            } else {
                vue.$store.commit('setNotAdmin');
            }

            setTimeout(() => {
                thisConst.checkAuth(vue, null);
                // }, 1000); // 1 sec
            }, 1000 * 60 * 60); // 1 hour
        } else {
            this.setAuthHeader('');
            this.saveToken('');
            vue.$store.commit('setNotAuth');
            vue.$store.commit('setNotAdmin');
        }
    }

    public checkAuth(vue: any, http: any | null) {
        if (http === null || http === undefined) {
            http = Axios;
        }

        let token = this.getToken();
        if (token !== null) {
            this.setAuthHeader(token);
        }

        const obj = this;

        let auth = false;
        let admin = false;
        http.get('/API/testAuth').then((resp: any) => {
            if (resp.status === 204) {
                throw new Error('Not authorized!');
            }

            const data: LoginResponse = resp.data;
            const tokenString: string = data.Token;

            auth = true;
            token = tokenString;
            admin = data.Admin;

            vue.$store.commit('setEmail', data.Email);
        }).catch(() => {
            auth = false;
            token = '';
        }).finally(() => {
            obj.setAuth(vue, auth, admin, token);
            vue.$store.commit('setToken', token);
        });
    }

    public logout(vue: any) {
        this.setAuth(vue, false, false, '');
    }

    private setAuthHeader(token: string) {
        if (token === '') {
            Axios.defaults.headers.common.Authorization = 'Basic 0000';
        } else {
            Axios.defaults.headers.common.Authorization = 'Basic ' + token;
        }
    }

    private saveToken(token: string) {
        if (token === '') {
            localStorage.removeItem('Authentication token');
        } else {
            localStorage.setItem('Authentication token', token);
        }
    }

}

const AuthManager = new AuthManagerClass();

export default AuthManager;
